import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';

interface Prop {
    orders: any;
    commodity: any;
}
interface State {}

@injectIntl()
export default class OrderExtra extends Base<Prop, State> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {}

    render() {
        const { orders = [], commodity = {} } = this.props;
        return (
            <>
                <div className="m-orderItem">
                    <div className="row-2" style={{ paddingBottom: '10px' }}>
                        <div>
                            <span className="tips">
                                <FormattedMessage id="payment" /> :
                            </span>
                            <span className="tips2">
                                <FormattedMessage id="cod" />
                            </span>
                        </div>
                        <div>
                            <span className="tips">
                                <FormattedMessage id="freight-charge" /> :
                            </span>
                            <span className="tips2">
                                {commodity.currencyDisplayPosition === 'BEFORE_AMOUNT' && commodity.currencyDisplay}{' '}
                                {orders?.length > 0 &&
                                    orders?.reduce(
                                        (total: number, item: any) => total + item.logisticsFee + item.remoteLogisticsFee,
                                        0,
                                    )}
                                {commodity.currencyDisplayPosition === 'AFTER_AMOUNT' && commodity.currencyDisplay}
                            </span>
                        </div>
                        <div>
                            <span className="tips">
                                <FormattedMessage id="order-success.could-pay" /> :
                            </span>
                            <span className="tips2" style={{ color: '#ff5a5f', fontWeight: 'bold' }}>
                                {commodity.currencyDisplayPosition === 'BEFORE_AMOUNT' && commodity.currencyDisplay}
                                {orders?.length > 0 && orders?.reduce((total: number, item: any) => total + item.totalPrice, 0)}
                                {commodity.currencyDisplayPosition === 'AFTER_AMOUNT' && commodity.currencyDisplay}
                            </span>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
